import React from "react";

const FinancialTable = ({ title, rows = [] }) => (
  <div className="panel">
    <div className="card-title" style={{ marginBottom: 6 }}>
      {title}
    </div>
    <table className="table">
      <tbody>
        {rows.map((row) => (
          <tr key={row.label}>
            <td>{row.label}</td>
            <td style={{ textAlign: "right" }}>{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default FinancialTable;
